import { $, html, View } from 'rune-ts';
import klass from '../FanLetterList.module.scss';
import { FanLetterFormTextAreaFocusEvent, FanLetterFormTextAreaInputEvent } from '../events/FanLetterEvents';
import { textareaTrim } from '@services/MarppleShop/shared/util/trim.ts';
import { font } from '@services/MarppleShop/shared/typography';

interface FanLetterFormTextAreaData {
  max_count: number;
  is_login: boolean;
  is_mobile: boolean;
  small_mode: boolean;
  mode: 'small' | 'medium' | 'large';
}

export class FanLetterFormTextAreaView extends View<FanLetterFormTextAreaData> {
  private min_count = 5;
  private max_count = Math.max(this.data.max_count, this.min_count);
  private text_value = '';

  protected override template() {
    return html`
      <textarea
        class="${klass.form_textarea} ${this._modeTo().font}"
        placeholder="${html.preventEscape(this._makePlaceHolder())}"
      >
${this.text_value}</textarea
      >
    `;
  }

  private _modeTo() {
    if (this.data.mode == 'small') {
      return { font: font('14_medium') };
    }
    if (this.data.mode == 'large') {
      return { font: font('16_medium') };
    }
    return { font: font('14_medium') };
  }

  private _makePlaceHolder() {
    if (this.data.small_mode) {
      return this.data.is_login
        ? ET('creator_shop::fan_letters::placeholder_mo_login')
        : ET('creator_shop::fan_letters::placeholder_mo_logout');
    } else {
      return this.data.is_login
        ? ET('creator_shop::fan_letters::placeholder_pc_login')
        : ET('creator_shop::fan_letters::placeholder_pc_logout');
    }
  }

  private _getValue$() {
    const text_area$ = this.element() as HTMLInputElement;
    if (text_area$) {
      return textareaTrim(text_area$.value);
    }
    return '';
  }

  private _setValue$(value: string) {
    const text_area$ = this.element() as HTMLInputElement;
    if (text_area$) {
      text_area$.value = textareaTrim(value);
    }
    return this.setTextValue(value);
  }

  private _getIsOverMinCount$() {
    const value_length = this.getTextValue().length;
    return value_length > this.min_count;
  }

  private _setValueMaxCount$(text_value: string) {
    return this._setValue$(text_value.substring(0, this.max_count));
  }

  public getTextValue() {
    return this.text_value;
  }

  public setTextValue(text_value: string) {
    this.text_value = textareaTrim(text_value);
    return this;
  }

  public setSmallMode(mode: boolean) {
    this.data.small_mode = mode;
    return this;
  }

  public toggleWithImages(has_images: boolean) {
    if (has_images) {
      $(this.element()).addClass(klass.has_images);
    } else {
      $(this.element()).removeClass(klass.has_images);
    }
  }

  protected override onRender() {
    this.addEventListener('input', () => {
      const text_value = this._getValue$();

      if (text_value.length > this.max_count) {
        this._setValueMaxCount$(text_value);
      } else {
        this.setTextValue(text_value);
      }

      this.dispatchEvent(FanLetterFormTextAreaInputEvent, {
        bubbles: true,
        detail: {
          value_length: this.getTextValue().length,
          is_over_min_count: this._getIsOverMinCount$(),
        },
      });
    });
    this.addEventListener('focus', () => {
      this.dispatchEvent(FanLetterFormTextAreaFocusEvent, {
        bubbles: true,
        detail: {
          focus: true,
        },
      });
    });
    this.addEventListener('blur', () => {
      this.dispatchEvent(FanLetterFormTextAreaFocusEvent, {
        bubbles: true,
        detail: {
          focus: false,
        },
      });
    });
  }
}
